<app-page
  [config]="pageConfig$ | async"
  [content]="content"
  [action]="(displayActionButtons$ | async) ? action : null"
/>

<ng-template #content>
  <div class="lrn-player-container">
    <div
      id="lrn-player-container"
      class="lrn-player-container standard-mcq"
      [ngClass]="'number-recall'"
      data-ua-id="learnosity-player"
    >
      <div id="learnosity_assess"></div>
    </div>
  </div>
</ng-template>

<!-- Number buttons template -->
<ng-template #numberButtonsTemplate>
  <div class="buttons-container text-center">
    <div class="buttons-grid">
      <div class="numeric-pad">
        <!-- Number buttons -->
        @for (i of numberpad; track i) {
          <button
            [ngClass]="{ 'numeric-button': true, pressed: isPressed(i) | async }"
            (pointerdown)="handleNumber(i, $event)"
          >
            <span>{{ i }}</span>
          </button>
        }

        <button
          (pointerdown)="handleClearAll($event)"
          aria-label="clear"
        >
          <span class="font-size-16">clear</span>
        </button>

        <button
          [ngClass]="{ 'numeric-button': true, pressed: isPressed('0') | async }"
          (pointerdown)="handleNumber('0', $event)"
        >
          <span>0</span>
        </button>

        <button
          [ngClass]="{ pressed: isPressed(backspace) | async }"
          (pointerdown)="handleBackspace($event)"
        >
          <span>
            <apt-icon
              auto-id="als-number-recall-backspace-icon"
              icon="backspace-solid"
              ariaLabel="Backspace"
            />
          </span>
        </button>
      </div>

      <button
        class="btn btn-submit rounded-pill font-size-18 text-capitalize text-white border-0"
        aria-label="submit button"
        disabled
        (pointerdown)="navigateToNextItem()"
      >
        <span>Submit</span>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #action>
  @if (testletActionButtonsConfig$ | async; as config) {
    <app-testlet-action-buttons
      [config]="config"
      (buttonClicked)="handleButtonClicked($event)"
    />
  }
</ng-template>
